import { cancelParcelValues } from '@/parcels/pages/ParcelDetailPage/constants'

export const cancelParcelOptions = [
  { label: 'No', value: cancelParcelValues.no },
  {
    label: 'No, pero reestablece el estado de fulfillment de los productos',
    value: cancelParcelValues.resetFulfillment,
  },
  { label: 'Sí, cancelar también el pedido asociado', value: cancelParcelValues.cancelOrder },
]
